module.exports = __webpack_public_path__ + "img/22800.bb9d0759.jpg";